module.exports = __webpack_public_path__ + "static/media/ppt-yd1.31ebf648.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lecture/ppt-yd1.png
// module id = 2002
// module chunks = 6